"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
exports.setDownloadAsset = function (downloadAsset) {
    return toolkit_1.createAction(constants_1.SET_DOWNLOAD_ASSET)(downloadAsset);
};
exports.setAllDownloadAssets = function (downloadAssets) {
    return toolkit_1.createAction(constants_1.SET_ALL_DOWNLOAD_ASSETS)(downloadAssets);
};
exports.removeDownloadAsset = function (assetId) {
    return toolkit_1.createAction(constants_1.REMOVE_DOWNLOAD_ASSET)(assetId);
};
exports.setDownloadSettings = function (downloadSettings) {
    return toolkit_1.createAction(constants_1.SET_DOWNLOAD_SETTINGS)(downloadSettings);
};
exports.setWifiOnly = function (wifiOnly) { return toolkit_1.createAction(constants_1.SET_WIFI_ONLY)(wifiOnly); };
//# sourceMappingURL=actions.js.map